import * as React from 'react'
import { useSpring, animated, useTransition, config } from 'react-spring'

type Props = {

}

const ProbeAnimation: React.FC<Props> = ({ }: Props) => {
  const frames = [
    {
      src: '/imgs/channel-recommender/probe-animation/frame1.svg',
      duration: 500
    },
    {
      src: '/imgs/channel-recommender/probe-animation/frame2.svg',
      duration: 2000
    },
    {
      src: '/imgs/channel-recommender/probe-animation/frame1.svg',
      duration: 500
    },
    {
      src: '/imgs/channel-recommender/probe-animation/frame3.svg',
      duration: 2000
    },
    {
      src: '/imgs/channel-recommender/probe-animation/frame1.svg',
      duration: 500
    },
    {
      src: '/imgs/channel-recommender/probe-animation/frame4.svg',
      duration: 2000
    },
  ]
  const [index, setIndex] = React.useState<number>(0)

  const transitions = useTransition(1, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    delay: 0,
    config: config.molasses,
    onRest: () => setIndex(0),
  })
  // const style = useSpring({ 
  //   to: { opacity: 1 }, 
  //   from: { opacity: 0 }, 
  //   delay: 0, 
  //   config: { duration: 500 },
  //  })

  React.useEffect(() => {
    const currentFrame = frames[index];
    const nextIndex = index+1 === frames.length? 0 : index+1;
    const timerId = setTimeout(() => {
      setIndex(nextIndex)
    }, currentFrame.duration);
    return () => {
      clearTimeout(timerId);
    }

  }, [index]);



  return (
    <div>
      {transitions(({ opacity }, item) => {
        return <animated.div
          style={{
            opacity: opacity
          }}>
           <img
            src={frames[index].src}
            className=" rounded p-1" />
        </animated.div>
})}
    </div>
  );
}

export default ProbeAnimation;


